var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        _vm.fitScreen1366 && _vm.$store.getters.isLowerThenScreen1366
          ? "screen1366"
          : "",
      staticStyle: {
        display: "flex",
        "justify-content": "flex-start",
        margin: "0px 3px",
        "flex-wrap": "wrap"
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSumVisible,
              expression: "isSumVisible"
            }
          ]
        },
        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AllAmountP") + _vm.numAll))]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSumVisible,
              expression: "isSumVisible"
            }
          ],
          staticStyle: { margin: "0px 10px" }
        },
        [
          _vm._v(
            _vm._s(
              _vm.$t("CargoMsg.Cargo_SelectedItems", [
                "[" + _vm.numSelected + "]"
              ])
            )
          )
        ]
      ),
      _c("span", { staticStyle: { "font-size": "12px" } }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._l(_vm.dynamicChildren, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticStyle: { "padding-right": "2px", "font-size": "12px" }
          },
          [
            item.type === "label"
              ? _c("span", [_vm._v(_vm._s(item.text))])
              : _vm._e(),
            item.type === "input"
              ? _c("div", {
                  staticClass: "input-div",
                  style: { width: item.text.length * 5 + 25 + "px" },
                  domProps: { textContent: _vm._s(item.text) }
                })
              : _vm._e()
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }